import { FC } from "react";

import { VnBox } from "@/components/VnBox";
import { BrokerConsentAnswerType } from "@/domain/brokerConsent";

import { ApplicationYesNoButton } from "./ApplicationYesNoButton";

type BrokerConsentAnswerButtonsPropsType = {
  selectedAnswer: BrokerConsentAnswerType | null;
  onAnswerPress: (answer: BrokerConsentAnswerType) => void;
  isLoading?: boolean;
  isDisabled?: boolean;
};

export const BrokerConsentAnswerButtons: FC<
  BrokerConsentAnswerButtonsPropsType
> = ({ selectedAnswer, onAnswerPress, isLoading, isDisabled }) => (
  <VnBox className="gap-3">
    <ApplicationYesNoButton
      titleI18nKey="native:brokerConsent.yesButton"
      badgeI18nKey="native:brokerConsent.recommendedBadge"
      isLoading={isLoading && selectedAnswer === "yes"}
      isDisabled={isDisabled}
      isSelected={selectedAnswer === "yes"}
      onPress={() => {
        onAnswerPress("yes");
      }}
    />
    <ApplicationYesNoButton
      titleI18nKey="native:brokerConsent.noButton"
      isLoading={isLoading && selectedAnswer === "no"}
      isDisabled={isDisabled}
      isSelected={selectedAnswer === "no"}
      onPress={() => {
        onAnswerPress("no");
      }}
    />
  </VnBox>
);
